import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { migrateLegacyDrafts } from './lib/persistence';

// Flyttar gamla lokala utkast till lagringslagret en gång per webbläsare.
migrateLegacyDrafts();


// Version bump to force cache clear
const APP_VERSION = Date.now().toString();
console.log('🚀 App Version:', APP_VERSION);

// Clear Service Workers to prevent aggressive caching
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    registrations.forEach(registration => registration.unregister());
  });
}

// Debug: Expose React globally to verify single instance
if (typeof window !== 'undefined') {
  (window as any).React = React;
}

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root element not found");
}

const root = createRoot(container);
root.render(
  <App />
);
